import { axiosInstance } from './api';

/** План заказа (Алексей 27.10 #2972) — BE plugins/ops_tasks/api/order_plan.py. Справочно: чего не хватило. */
export type OrderPlanNoteKind = 'speech' | 'review' | 'voice';

export interface OrderPlanNote {
  kind: OrderPlanNoteKind;
  at: string;
  text: string;
  quote: string;
  conversation_id?: number;
  review_id?: number;
}

export interface OrderPlanItem {
  name: string;
  count: number;
  last_at: string;
  kinds: OrderPlanNoteKind[];
  notes: OrderPlanNote[];
}

export interface OrderPlanDto {
  date_from: string;
  date_to: string;
  sources: { mic: boolean; reviews_maps: boolean; review_form: boolean };
  items: OrderPlanItem[];
}

export const getOrderPlan = (zoneId: string, dateFrom?: string, dateTo?: string) =>
  axiosInstance.get<OrderPlanDto>(`/ops_tasks/order-plan/${zoneId}/`, { params: { date_from: dateFrom, date_to: dateTo } });
